import React from "react";
import Image from "../assets/IAM-Advisory-2.png";
import { Card, Col, Container, ListGroup, Row } from "react-bootstrap";
import { FaQuoteLeft } from "react-icons/fa";
import { FaQuoteRight } from "react-icons/fa";
import { SiTicktick } from "react-icons/si";
import BG from "../assets/Blue.png";
import Footer from "../components/Footer";
import '../utils/effectCSS/Effects.css';

const MultiFactorAuthentication = () => {
  return (
    <>
      <Container
        fluid
        className="py-5"
        style={{
          backgroundImage: "url(" + BG + ")",
        }}
      >
        <div
          style={{
            height: "70px",
          }}
        ></div>
        <h2 className="text-center p-4">
          <b>Multi-Factor Authentication</b>
        </h2>

        <hr
          className="d-flex justify-content-center"
          style={{
            width: "10%",
            border: "1.5px solid blue",
            margin: "0 auto",
          }}
        />

        <div className="mt-5">
          <Row>
            <Col lg={2} className="d-flex justify-content-end">
              <FaQuoteLeft
                style={{
                  color: "#00FFFF",
                  fontSize: "25px",
                }}
              />
            </Col>

            <Col lg={8}>
              <Container fluid className="text-center">
                <p
                  style={{
                    fontSize: "1.25rem",
                  }}
                >
                  Consider Identity Management as your Digital ID, Access Management as the keycard, and MFA as the final passcode. Together, they guarantee that only authorized individuals access the right resources when needed, securing your business with precision and control.
                </p>
              </Container>
            </Col>

            <Col
              lg={2}
              className="d-flex align-items-start justify-content-start"
            >
              <FaQuoteRight
                style={{
                  color: "#00FFFF",
                  fontSize: "25px",
                }}
              />
            </Col>
          </Row>
        </div>
        <Container>
          <Row className="mt-5 align-items-stretch">
            <Col className="d-flex" lg={6} xs={12}>
              <img className="img-fluid" src={Image} alt="IAM" />
            </Col>
            <Col className="d-flex" lg={6} xs={12}>
              <Container
                className="flex-fill"
                style={{
                  backgroundColor: "#6495ED",
                  color: "white",
                  padding: "4rem 2rem",
                }}
              >
                <h4 className="">Why IDM 360 Analytics for Implementing Multi-Factor Authentication</h4>

                <div className="mt-2">
                  <ListGroup className="border-0 bg-transparent ">
                    <ListGroup.Item className="border-0 bg-transparent text-white">
                      <SiTicktick className="me-3" />
                      Comprehensive Solutions – IDM 360 Analytics provides an integrated
                      approach to access management, combining MFA with
                      streamlined user provisioning, precise access control, and
                      robust governance frameworks. Stay ahead of risks with
                      real-time insights into user behavior and emerging
                      threats, empowering your organization to take proactive
                      measures and enhance security.
                    </ListGroup.Item>
                    <ListGroup.Item className="border-0 bg-transparent text-white">
                      <SiTicktick className="me-3" />
                      User-Centric Approach – IDM 360 Analytics designs inclusive,
                      easy-to-use MFA solutions that ensure a smooth user
                      experience. Our intuitive approach reduces disruptions,
                      streamlines workflows, and boosts adoption, making
                      security effortless in daily operations.
                    </ListGroup.Item>
                    <ListGroup.Item className="border-0 bg-transparent text-white">
                      <SiTicktick className="me-3" />
                      MFA Expertise – Finding the right MFA experts shouldn’t be
                      a challenge. IDM 360 Analytics is a trusted partner for top
                      organizations, delivering reliable and robust security
                      solutions backed by years of experience.
                    </ListGroup.Item>
                  </ListGroup>
                </div>
              </Container>
            </Col>
          </Row>
        </Container>
        <Card className="bg-transparent border border-0 text-black p-5 text-center">
          <Card.Body>
            <h3 className="text-center mb-4">
              <b>
                Implement Multi-Factor Authentication for a Resilient Digital
                Ecosystem.
              </b>
            </h3>
            <hr
              className="d-flex justify-content-center"
              style={{
                width: "10%",
                border: "1.5px solid blue",
                margin: "0 auto",
              }}
            />
            <Container>
              <Row xs={1} lg={3}>
                <Col lg={2}></Col>
                <Col lg={8} className="mt-4">
                  <p
                    style={{
                      fontSize: "1.25rem",
                    }}
                  >
                    99.9% of account hacks are prevented with Multi-Factor
                    Authentication (MFA), safeguarding your sensitive
                    information. However, implementing MFA can present
                    challenges such as user adoption, complexity, cost,
                    integration, and accessibility. IDM 360 Analytics is your trusted
                    partner, transforming MFA from a hurdle into a seamless
                    security advantage.
                  </p>
                  <p className="mt-5" style={{
                      fontSize: "1.25rem",
                    }} >
                    In today’s digital world, ignoring data security is like leaving your front door wide open. Choose IDM 360 Analytics as your security partner to build a digital fortress that shields your data from even the most persistent threats.
                  </p>
                </Col>
                <Col lg={2}></Col>
              </Row>
            </Container>
          </Card.Body>
        </Card>

        <Container className="p-0">
          {/* First Row */}
          <Row className="justify-content-center g-3 align-items-stretch">
            <Col lg={4} className="d-flex hover-left">
              <Container
                className="flex-fill text-center"
                style={{
                  padding: "4rem",
                  backgroundColor: "#3457D5",
                  color: "white",
                }}
              >
                <h5>Preparation</h5>
              </Container>
            </Col>

            <Col lg={6} className="d-flex hover-right">
              <Container
                className="flex-fill border border-1 shadow-lg"
                style={{
                  padding: "2rem",
                  backgroundColor: "white",
                  fontSize: "13px",
                }}
              >
                <p>
                  Through detailed risk assessments and system evaluations, we prepare your organization for a seamless MFA transition, ensuring that the right security measures are in place to protect critical assets and data. We help you lay the groundwork for a successful Multi-Factor Authentication (MFA) rollout.
                </p>
              </Container>
            </Col>
          </Row>
          {/* Second Row */}
          <Row className="justify-content-center g-3 mt-1 align-items-stretch">
            <Col lg={6} className="d-flex order-2 order-lg-1 hover-left">
              <Container
                className="flex-fill border border-1 shadow-lg"
                style={{
                  padding: "2rem",
                  backgroundColor: "white",
                  fontSize: "13px",
                }}
              >
                <p>
                  Our expert team ensures smooth integration with your existing systems, providing step-by-step guidance throughout the deployment process. We tailor the implementation to fit your unique business needs, ensuring robust protection against unauthorized access while maintaining user convenience.
                </p>
              </Container>
            </Col>

            <Col lg={4} className="d-flex order-1 order-lg-2 hover-right">
              <Container
                className="flex-fill text-center"
                style={{
                  padding: "4rem",
                  backgroundColor: "#1ca9c9",
                  color: "white",
                }}
              >
                <h5>MFA Implementation</h5>
              </Container>
            </Col>
          </Row>
          {/* Third Row */}
          <Row className="justify-content-center g-3 mt-1 align-items-stretch">
            <Col lg={4} className="d-flex hover-left">
              <Container
                className="flex-fill text-center"
                style={{
                  padding: "4rem",
                  backgroundColor: "#3457D5",
                  color: "white",
                }}
              >
                <h5>Maintenance</h5>
              </Container>
            </Col>

            <Col lg={6} className="d-flex hover-right">
              <Container
                className="flex-fill border border-1 shadow-lg"
                style={{
                  padding: "2rem",
                  backgroundColor: "white",
                  fontSize: "13px",
                }}
              >
                <p>
                  Our proactive approach includes regular updates, system monitoring, and troubleshooting to address potential issues before they affect your operations. We ensure that your MFA system evolves with the latest security trends, keeping your organization protected at all times.
                </p>
              </Container>
            </Col>
          </Row>
        </Container>
      </Container>
      <div className="mt-4">
        <Footer />
      </div>
    </>
  );
};

export default MultiFactorAuthentication;
